export class OwnerAssistEntity {

    ID: string;
    VALUE: number;
    IS_EXCLUDED: boolean;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }
}